import React from "react"
import PricingCalculator from "./pricing-calculator-component"
import { CheckIcon } from "@heroicons/react/20/solid"
import pricingConfig from "/pricing.config"
import { Link } from 'gatsby';

const {
  features,
  ...pricing
} = pricingConfig

export default function PricingComponent() {
  return (
    <div className="bg-white mb-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
  
        <div
          className="mx-auto mt-16 max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
            <h3 className="text-2xl font-bold tracking-tight text-gray-900">
              Status Page
            </h3>
            <p className="mt-6 text-base leading-7 text-gray-600">
              A direct line of communication with your customers, delivering real-time updates on system status,
              maintenance windows, and incident reports.
            </p>
            <div className="mt-10 flex items-center gap-x-4">
              <h4 className="flex-none text-sm font-semibold leading-6 text-brand-600">
                What’s included
              </h4>
              <div className="h-px flex-auto bg-gray-100" />
            </div>
            <ul
              className="mt-8 grid grid-cols-1 gap-4 text-sm leading-6 text-gray-600 sm:gap-5"
            >
              {features.map((feature) => (
                <li key={feature} className="flex gap-x-3">
                  <CheckIcon
                    className="h-6 w-5 flex-none text-brand-600"
                    aria-hidden="true"
                  />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
          <PricingCalculator pricing={pricing} />
        </div>
        <br></br>
        <div class="flex flex-col items-start gap-x-8 gap-y-6 rounded-3xl p-8 ring-1 ring-gray-900/10 sm:gap-y-10 sm:p-10 lg:col-span-2 lg:flex-row lg:items-center">
            <div class="lg:min-w-0 lg:flex-1">
              <h3 className="text-2xl font-bold tracking-tight text-gray-900">Status Page for Enterprise</h3>
              <p className="mt-6 text-base leading-7 text-gray-600">We are meeting the unique needs of enterprise clients through dedicated account management for personalised support and expert guidance, flexible billing options, and custom End-User License Agreements (EULA).</p>
            </div>
            <Link to="/demo" class="rounded-md px-3.5 py-2 bg-gray-900 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-800">Schedule a Demo<span aria-hidden="true">&rarr;</span></Link>
          </div>
      </div>
    </div>
  )
}
